// extracted by mini-css-extract-plugin
export default {"iconAlign":"iconAlign---FUpLh"};